import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { v4 as uuid } from 'uuid';
import { controlClasses, safeInvoke } from '../../../../library';
import { ChoiceGroupContext, RadioGroupContext } from './choice-group';
var choiceClasses = {
  "switch": 'switch',
  checkbox: 'checkbox',
  radio: 'radio'
};
var Choice = function Choice(props) {
  var _props$field;
  var defaults = React.useContext(ChoiceGroupContext);
  var mergedProps = _objectSpread(_objectSpread({}, defaults), props);
  var id = React.useRef((_props$field = props.field) !== null && _props$field !== void 0 ? _props$field : "".concat(mergedProps.type, "-") + uuid());
  var classNames = cn(mergedProps.typeClassName, controlClasses({
    size: mergedProps.size
  }), {
    '-disabled': mergedProps.isDisabled,
    '-readonly': mergedProps.isReadOnly
  }, mergedProps.className);
  function handleChange(e) {
    if (mergedProps.isReadOnly) {
      e.preventDefault();
      return;
    }
    var isChecked = e.target.checked;
    safeInvoke(mergedProps.onUpdate, id.current, isChecked, e);
    safeInvoke(mergedProps.onChange, e);
  }
  return React.createElement("div", {
    className: classNames
  }, React.createElement("input", {
    id: id.current,
    type: mergedProps.type,
    onChange: handleChange,
    onBlur: mergedProps.onBlur,
    checked: mergedProps.isChecked,
    name: mergedProps.name,
    value: mergedProps.value,
    disabled: mergedProps.isDisabled
  }), React.createElement("label", {
    htmlFor: id.current
  }, mergedProps.children, mergedProps.label), !!mergedProps.note && React.createElement("div", {
    className: "note"
  }, mergedProps.note));
};
export var Switch = function Switch(props) {
  return React.createElement(Choice, _extends({}, props, {
    type: "checkbox",
    typeClassName: choiceClasses["switch"]
  }), React.createElement("div", {
    className: "indicator"
  }));
};
Switch.displayName = 'Switch';
export var Checkbox = function Checkbox(props) {
  return React.createElement(Choice, _extends({}, props, {
    type: "checkbox",
    typeClassName: choiceClasses.checkbox
  }));
};
Checkbox.displayName = 'Checkbox';
export var Radio = function Radio(props) {
  var _React$useContext = React.useContext(RadioGroupContext),
    name = _React$useContext.name,
    activeValue = _React$useContext.activeValue;
  var isChecked = !!activeValue && activeValue === props.value;
  return React.createElement(Choice, _extends({
    isChecked: isChecked,
    name: name
  }, props, {
    type: "radio",
    typeClassName: choiceClasses.radio
  }));
};
Radio.displayName = 'Radio';